import axios from "../../../axios"
import { getCurrentTenant, formatGraphqlBody } from '@/utils'

export default{
    add(data) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
            return axios.post('', {
            query: `
                    mutation {
                        createRelationshipRuleCategoryPivot (
                            relationship_rule_id: ${data.relationship_rule_id},
                            category_id: ${data.category_id},
                        ) {
                            relationshipRule {
                                id
                                name
                            }
                            category {
                                id
                                name
                            }
                        }
                    }
                `
            })
    },
    delete(id) {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
            return axios.post('', {
            query: `
                    mutation {
                        deleteRelationshipRuleCategoryPivot (
                            id: ${id}
                        )
                    }
                `
            })
    },
    fetch() {
        axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql';
        return axios.post('', {
            query: `
                query {
                    relationshipRuleCategoriesPivot {
                        relationshipRule {
                            id
                            name
                        }
                        category {
                            id,
                            name,
                            color_tag
                        }
                    }
                }
            `
        })
    },
}